import { animate, state, style, transition, trigger } from "@angular/animations";
import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  Input, OnInit,
  QueryList,
  ViewEncapsulation
} from "@angular/core";
import { KzAccordionItem } from "./directives/kz-accordion-item.directive";
import { AccordionContext } from './accordion-options';
/*
* Souces :
* https://sreyaj.dev/customizable-accordion-component-angular#heading-code-and-demo
* https://codesandbox.io/s/ng-accordion-ssscp?file=/src/app/app.component.html:1508-2009
* https://codesandbox.io/s/ng-accordion-optimized-49bxr?file=/src/app/lib/accordion/pipe/toggle.pipe.ts
* */
@Component({
  selector: "kz-accordion",
  templateUrl: "./kz-accordion.component.html",
  styleUrls: ["./kz-accordion.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('contentExpansion', [
      state('expanded', style({height: '*', opacity: 1, visibility: 'visible'})),
      state('collapsed', style({height: '0px', opacity: 0, visibility: 'hidden'})),
      transition('expanded <=> collapsed',
        animate('200ms cubic-bezier(.37,1.04,.68,.98)')),
    ])
  ],
  host: {
    class: 'kz-accordion-container'
  }
})
export class KzAccordionComponent implements OnInit {
  expanded = new Set<number>();

  private _accordionContext: AccordionContext = undefined;

  get accordionContext(): AccordionContext {
    return this._accordionContext;
  }

  @Input()
  set accordionContext(value: AccordionContext) {
    this._accordionContext = value;
  }
  /**
   * Decides if the single item will be open at once or not.
   * In collapsing mode, toggling one would collapse others
   */
  @Input() collapsing = true;
  @Input() firstItemOpened = true;

  @ContentChildren(KzAccordionItem) items: QueryList<KzAccordionItem>;


  ngOnInit() {
    if (this.firstItemOpened) {
      this.expanded.add(0);
    }
  }

  /**
   * Make the toggle function available to be called from
   * outside.
   * @param index - index of the accordion item
   */

  toggleState = (index: number) => {
    if (this.expanded.has(index)) {
      this.expanded.delete(index);
    } else {
      if (this.collapsing) {
        this.expanded.clear();
      }
      this.expanded.add(index);
    }
  };
}
